$('body').removeClass('no-js');

//Initialize Accordion
new Accordion(".accordion-container");

//Carousel Script
if (document.querySelector(".glide__slides")) {
  var allSlides = document.querySelectorAll(".glide");
  let allSlidesArray = Array.prototype.slice.call(allSlides);
  allSlidesArray.forEach(slide => {
    const glide = new Glide(slide, {
      type: "slider",
      perView: 1,
      perTouch: 1,
      focusAt: "center",
      autoplay: false,
      accessibility: true,
      startAt: 2,
      rewind: false,
      classes: {
        disabledArrow: "glide__arrow--disabled"
      },
      peek: {
        before: 215,
        after: 215
      },
      perSwipe: "|",
      breakpoints: {
        800: {
          perView: 1,
          peek: 400
        }
      }
    }).mount();
  });
}

// //meet people
if (document.querySelector(".team_glide")) {
  var team_allSlides = document.querySelector(".team_glide-container");
  const glide = new Glide(team_allSlides, {
    type: "slider",
    perView: 3,
    perTouch: 3,
    focusAt: "center",
    autoplay: false,
    accessibility: true,
    startAt: 1,
    rewind: false,
    classes: {
      disabledArrow: "glide__arrow--disabled"
    },
    peek: {
      before: 215,
      after: 215
    },
    perSwipe: "|",
    breakpoints: {
      800: {
        perView: 1,
        peek: 0
      }
    }
  }).mount();
}

//For latest Vacancies Carousel
if (document.querySelector(".latest-vacancies-section")) {
  var latestVacancies = document.querySelector(".latest-vacancies-section");
  const glide = new Glide(latestVacancies, {
    type: "slider",
    focusAt: 0,
    perView: 4,
    perTouch: 1,
    touchRatio: 1,
    autoplay: false,
    rewind: false,
    perSwipe: "|",

    breakpoints: {
      768: {
        perView: 2,
        peek: {
          before: 0,
          after: 64
        }
      },
      1024: {
        perView: 3
      },
      480: {
        perView: 1,
        peek: {
          before: 0,
          after: 64
        }
      }
    }
  }).mount();
}

//Polyfill for Append
(function (arr) {
  arr.forEach(function (item) {
    if (item.hasOwnProperty('append')) {
      return;
    }
    Object.defineProperty(item, 'append', {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function append() {
        var argArr = Array.prototype.slice.call(arguments),
          docFrag = document.createDocumentFragment();

        argArr.forEach(function (argItem) {
          var isNode = argItem instanceof Node;
          docFrag.appendChild(isNode ? argItem : document.createTextNode(String(argItem)));
        });

        this.appendChild(docFrag);
      }
    });
  });
})([Element.prototype, Document.prototype, DocumentFragment.prototype]);

//Polyfill for prepend
(function (arr) {
  arr.forEach(function (item) {
    if (item.hasOwnProperty('prepend')) {
      return;
    }
    Object.defineProperty(item, 'prepend', {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function prepend() {
        var argArr = Array.prototype.slice.call(arguments),
          docFrag = document.createDocumentFragment();

        argArr.forEach(function (argItem) {
          var isNode = argItem instanceof Node;
          docFrag.appendChild(isNode ? argItem : document.createTextNode(String(argItem)));
        });

        this.insertBefore(docFrag, this.firstChild);
      }
    });
  });
})([Element.prototype, Document.prototype, DocumentFragment.prototype]);


//Menu
$(document).ready(function () {
  "use strict";
  $(".menu-main-menu-container > ul > li:has( > ul)").addClass("menu-dropdown-icon");
  $(".menu-main-menu-container > ul > li > ul:not(:has(ul))").addClass("normal-sub");
  $(".menu-main-menu-container").before('<div class="container"><a href="#" class="menu-mobile"><span></span><span class="screen-reader-text">Menu Toggle</span></a></div>');
  $(".menu-main-menu-container > ul > li").hover(function (e) {
    if ($(window).width() > 943) {
      //$(this).children("ul").stop(true, false).toggleClass('flex').attr("aria-expanded", true);
      //e.preventDefault();
    }
  });

  $(".menu-mobile").click(function (e) {
    $(".menu-main-menu-container > ul").toggleClass("show-on-mobile");
    $("header.site-header").toggleClass("fullheight");
    $(".menu-mobile").toggleClass("active-menu");
    $(".normal-sub").removeClass("slide-mobile-menu");
    $("#overlay").fadeToggle();
    $('body').toggleClass('no-scroll');
    if ($(".menu-mobile").hasClass('active-menu') == true) {
      var menuFromTop = $('.show-on-mobile').offset().top;
      $('.show-on-mobile').css('height', 'calc(100vh - ' + menuFromTop + 'px)');
    } else {
      $('#primary-menu').css('height', 'auto');
    }

    if ($('.back-to-main-menu').css('display') == 'block') {
      $('.menu-main-menu-container').css('background-color', 'transparent');
      $('.back-to-main-menu').css('display', 'none');
      $('.custom-logo-link').css('position', 'static');
    }

    e.preventDefault();
  });
});

let menuSubmenu = document.querySelectorAll(".menu-main-menu-container .menu-item-has-children");
if(menuSubmenu){
  let allmenuSubmenu = Array.prototype.slice.call(menuSubmenu);
    allmenuSubmenu.forEach(menu => {
    let parentName = menu.firstChild.lastChild.textContent;
  
    menu.children[0].setAttribute("aria-haspopup", "true");
    menu.children[1].setAttribute("aria-expanded", false);
    menu.children[1].setAttribute("aria-label", parentName);
  
    //Submenu Heading 
    if (window.innerWidth < 960) {
      let columnTitle = document.createElement("li");
      columnTitle.classList.add("column-title");     
  
      let columnTitleLink = document.createElement("a");
      columnTitleLink.href = menu.children[0].href;
      columnTitleLink.textContent = menu.children[0].children[0].textContent;
      //columnTitleLink.textContent = 'Test Text';
      
      columnTitle.append(columnTitleLink)
  
      menu.children[1].prepend(columnTitle);
  
      $("header.site-header").css('overflow', 'hidden');
    }
  });
}

let arrowDown = $(".menu-main-menu-container > ul > li > a > .arrowchevron");
arrowDown.on('keypress click', function (e) {
  $(this).parent().next().stop(true, false).toggleClass('flex').attr({ "aria-expanded": true, 'tabindex': 0 }).focus();
  e.preventDefault();
});


if (window.innerWidth < 960) {
  let btn = document.createElement("a");
  btn.classList.add("back-to-main-menu");
  btn.textContent = 'Back';
  document.querySelector('.menu-main-menu-container').prepend(btn);

  $(".menu-main-menu-container > ul > li > a").on("touch click", function (e) {
    // e.stopPropagation();
    if ($(this).parent().hasClass('menu-item-has-children')) {
      e.preventDefault();
      $('.arrowchevron').addClass('opacitytoggle');
    }

    $('.custom-logo-link').css('position', 'static');
    $(this).next().toggleClass("slide-mobile-menu");


    if ($(this).next().css("left") == "-100%") {
      //$(this).addClass("close-submenu");

    } else {
      //$(this).removeClass("close-submenu");
      $('.menu-main-menu-container').css('background-color', '#000000');
    }

    $('.back-to-main-menu').css('display', 'block');

    $('.back-to-main-menu').on('click', function () {
      $('.sub-menu').animate({ left: '-100%' }).removeClass('slide-mobile-menu');
      $(this).css('display', 'none');
      $('.menu-main-menu-container').css('background-color', 'transparent');
      $('.custom-logo-link').css('position', 'relative');
      $('.arrowchevron').removeClass('opacitytoggle');
    })

  });
}

////Pagination
if (document.querySelector(".navigation-pagination")) {
  let pagination = document.querySelectorAll(".navigation-pagination ul li");
  let paginationList = Array.prototype.slice.call(pagination);

  if (paginationList[0].classList.contains("active")) {
    paginationList[0].style.position = "relative";
  }

  if (paginationList[paginationList.length - 1].classList.contains("active")) {
    paginationList[paginationList.length - 1].style.position = "relative";
  }
}

if ($(".navigation-pagination ul li:first-child").find("svg").length > 0) {
  $(".navigation-pagination ul li:first-child").addClass("pagination-border");
}
if ($(".navigation-pagination ul li:last-child").find("svg").length > 0) {
  $(".navigation-pagination ul li:last-child").addClass("pagination-border-last");
}

if ($(".page-heading.only-desktop").length != 0) {
  $("article.page").css("padding", 0);
}

//Glide
if (document.querySelector(".allcontainer")) {
  var elem = document.querySelector(".allcontainer");
  var msnry = new Masonry(elem, {
    // options
    itemSelector: ".item",
    columnWidth: ".grid-sizer",
    gutter: 15
  });

  //Filters
  let allblocks = Array.prototype.slice.call(document.querySelectorAll(".item"));
  let selectedValue;
  let selectedOption;
  let availableItems;
  let buttons = document.querySelectorAll(".filters button"); //returns a nodelist

  for (let i = 0; i < buttons.length; i++) {
    buttons[i].addEventListener("click", onClickChange);
  }

  //Click Filter
  function onClickChange() {
    selectedValue = this.value;

    allblocks.forEach(function (block) {
      block.classList.remove("block");

      if (selectedValue == "all") {
        block.classList.add("block");
      }

      if (block.getAttribute("data-cat") == selectedValue) {
        block.classList.add("block");
      }
    });
    msnry.layout();

    availableItems = Array.prototype.slice.call(document.querySelectorAll(".item.block"));
    document.getElementById("select").addEventListener("change", onSelectChange);
  }

  availableItems = Array.prototype.slice.call(document.querySelectorAll(".item.block"));

  document.getElementById("select").addEventListener("change", onSelectChange);

  function onSelectChange() {
    selectedOption = this.value;

    availableItems.forEach(function (item) {
      item.classList.remove("block");

      if (selectedOption == "all") {
        item.classList.add("block");
      }

      if (item.getAttribute("data-tag") == selectedOption) {
        item.classList.add("block");
      }
    });

    //Filter Click
    for (let i = 0; i < buttons.length; i++) {
      buttons[i].addEventListener("click", onClickChange);
    }

    msnry.layout();
  }

  //Script_AJAX
  /* Ajax functions */
  $(document).ready(function () {
    //onclick
    $("#loadMore").on("click", function (e) {
      e.preventDefault();
      //init
      var that = $(this);
      var page = $(this).data("page");
      var newPage = page + 1;
      var ajaxurl = that.data("url");
      //ajax call
      $.ajax({
        url: ajaxurl,
        type: "post",
        data: {
          page: page,
          action: "ajax_script_load_more"
        },
        error: function (response) {
          console.log(response);
        },
        success: function (response) {
          //check
          if (response == 0) {
            $(".allcontainer").append('<div class="text-center no-more-post"><h4>You reached the end of the line!</h4><p>No more posts to load.</p></div>');
            $("#loadMore").hide();
          } else {
            that.data("page", newPage);
            $("#ajax-primary").append(response);

            msnry = new Masonry(elem, {
              // options
              itemSelector: ".item",
              columnWidth: ".grid-sizer",
              gutter: 15
            });

            msnry.layout();
          }
        }
      });
    });
  });
}


///Sticky Bar
window.onscroll = function () {
  if (document.querySelector(".sticky-nav")) {
    myFunction();
  }
};

var stickyCol = document.querySelector(".sticky-col");
var stickyNav = document.querySelector(".sticky-nav");
if (stickyNav) {
  var sticky = stickyNav.offsetTop;
}

function myFunction() {
  if (window.pageYOffset > sticky && window.innerWidth > 767) {
    stickyNav.classList.add("sticky");
    if (stickyCol) {
      stickyCol.classList.add("sticky");
    }
  } else if (window.pageYOffset > sticky && window.innerWidth < 768) {
    stickyNav.classList.add("sticky");
  } else {
    stickyNav.classList.remove("sticky");
    if (stickyCol) {
      stickyCol.classList.remove("sticky");
    }
  }
}

//Columns for Mega Menu
var mainMenu = document.querySelector("ul.nav-menu").getBoundingClientRect();
var navMenu = document.querySelectorAll("ul.nav-menu > li");
var ulListAll = document.querySelectorAll(".menu-main-menu-container ul.sub-menu");
var ulList = Array.prototype.slice.call(ulListAll);

ulList.forEach(ul => {

  if (ul.parentElement.classList.contains("col2") && window.innerWidth > 959) {
    ul.style.width = "742px";
    ul.style.left = "-370px";
    //ul.style.height = "490px";
  }
});

if (window.innerWidth > 959) {
  $("ul.nav-menu > li:nth-last-child(2)").find(".sub-menu").css({ left: "auto", right: '-143px' });
  $("ul.nav-menu > li:last-child").find(".sub-menu").css({ left: "auto", right: 0 });
}


//Tags Row Reverse
let allTagsRows = document.querySelectorAll(".tags-row");

for (let k = 0; k < allTagsRows.length; k += 2) {
  allTagsRows[k].classList.add("reverse");
}

//Padding Left in Tags list
//console.log((window.innerWidth - 1168) / 2);

let tagListAll = document.querySelectorAll(".tags-list");
let tagList = Array.prototype.slice.call(tagListAll);

tagList.forEach(tag => {
  tag.style.paddingLeft = (window.innerWidth - 1168) / 2 + "px";
});

//Tag next button Scroll
let tagsAll = document.querySelectorAll(".tag-container");
let tags = Array.prototype.slice.call(tagsAll);

tags.forEach(tag => {
  var button = tag.children[2];
  button.onclick = function () {
    var container = tag.children[0];
    sideScroll(container, "right", 25, 100, 10);
  };

  var back = tag.children[1];
  back.onclick = function () {
    var container = tag.children[0];
    sideScroll(container, "left", 25, 100, 10);
  };

  function sideScroll(element, direction, speed, distance, step) {
    scrollAmount = 0;
    var slideTimer = setInterval(function () {
      if (direction == "left") {
        element.scrollLeft -= step;
      } else {
        element.scrollLeft += step;
      }
      scrollAmount += step;
      if (scrollAmount >= distance) {
        window.clearInterval(slideTimer);
      }
    }, speed);
  }
});

//Scrollbar
window.addEventListener("scroll", this.handleScroll, true);

//Change active menu on Scroll Job Detail Page
$(".sticky-nav ul li a").on("click", function (event) {
  $(".sticky-nav ul li").removeClass("active");
  $(this)
    .parent()
    .addClass("active");
});

$(window).on("scroll", function () {
  $(".target").each(function () {
    if ($(window).scrollTop() >= $(this).offset().top) {
      var id = $(this).attr("id");
      $(".sticky-nav ul li").removeClass("active");
      $(".sticky-nav ul li a[href=#" + id + "]")
        .parent()
        .addClass("active");
    }
  });
});

//Back Button
$("#back-btn").on("click", function () {
  history.back();
});

//Change active menu on Scroll Tags Columns Block
$(".tags-list ul li a").on("click", function (event) {
  $(".tags-list ul li").removeClass("active");
  $(this)
    .parent()
    .addClass("active");
});

$(window).on("scroll", function () {
  $(".tags-row").each(function () {
    if ($(window).scrollTop() >= $(this).offset().top) {
      var id = $(this).attr("id");
      $(".sticky-nav ul li").removeClass("active");
      $(".sticky-nav ul li a[href=#" + id + "]")
        .parent()
        .addClass("active");
    }
  });
});

//Smooth Scroll
$('a[href*="#"]')
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .not('[href="#0"]')
  .click(function (event) {
    // On-page links
    if (location.pathname.replace(/^\//, "") == this.pathname.replace(/^\//, "") && location.hostname == this.hostname) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        $("html, body").animate(
          {
            scrollTop: target.offset().top
          },
          1000,
          function () {
            // Callback after animation
            // Must change focus!
            var $target = $(target);
            $target.focus();
            if ($target.is(":focus")) {
              // Checking if the target was focused
              return false;
            } else {
              $target.attr("tabindex", "-1"); // Adding tabindex for elements not focusable
              $target.focus(); // Set focus again
            }
          }
        );
      }
    }
  });

// //Show more Job detail page
// if ($('.full-content').length !== 0) {
//   var trimmed = [];
//   var trimContent = $('.trim-content');
//   var noofwords = $('.trim-content').html().split(' ');

//   if (noofwords.length > 100) {
//     for (var i = 0; i < 100; i++) {
//       trimmed.push(noofwords[i]);
//     }
//   } else {
//     for (var i = 0; i < noofwords - 1; i++) {
//       trimmed.push(noofwords[i]);
//     }
//   }

//   //trimContent.html($('.trim-content').html().substr(0, 300));
//   trimContent.html(trimmed.join(' '));

//   var readMore = $("<span/>").addClass('readmore').text('read more');
//   trimContent.find('p:last-child').append(readMore);

//   var showless = $("<span/>").addClass('showless').text('show less');
//   $('.full-content').find('p:last-child').append(showless);

//   $('.readmore').on('click', function () {
//     $('.trim-content-container').hide();
//     $('.full-content').show();
//   })

//   $('.showless').on('click', function () {
//     $('.full-content').hide();
//     $('.trim-content-container').show();
//   });
// }

//Advanced Filter Slide
$('.advanced-search').on('click', function () {
  $('.filters-container').slideToggle();
  $('.apply-filter').toggleClass('closeFilters');
})

//Banner
//   if (document.querySelector('.hero-content span')) {
//     let bannerContentWidth = document.querySelector('.hero-content span').offsetWidth,
//       borderTop = document.querySelector('.hero-hr-top span'),
//       borderbottom = document.querySelector('.hero-hr-bottom span');
  
//     borderTop.style.width = bannerContentWidth + 'px';
//     borderbottom.style.width = bannerContentWidth + 'px';
//   }

// window.addEventListener('resize', function(event){
//   console.log(document.querySelector('.hero-content span').offsetWidth);
// });

if ($('.banner.page-banner').hasClass('screen-reader-text')) {
  $('.banner.page-banner').next().find('article.page').css('padding-top', 0);
}

//$('.gray-bg').width(($('#secondary').width() + $('#secondary').offset().left));

var ua = window.navigator.userAgent;
var msie = ua.indexOf("MSIE ");

if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) 
{
    //For IE11 only
}
else { // For other browsers  
  window.addEventListener("load", () => {
    //focus on sort after reload
    var query_string = window.location.search;
    var urlParams = new URLSearchParams(query_string);
    var sorting = urlParams.get("sorting");  

    if(sorting){
      document.getElementById('sortingjob').focus();    
    }
  });
}


let submit = document.querySelector('.wpcf7-submit');
if(submit){  
  submit.setAttribute('aria-describedby', 'submit-msg');
  document.querySelector('.wpcf7-response-output').setAttribute('id', 'submit-msg');
}